<template>
  <div>
    <div class="content-header">
      <div class="container-fluid">
        <h1 class="m-0 text-dark">{{ $t('apAddFund')}}</h1>
      </div>
    </div>

    <div class="content">
      <div class="container-fluid">
        <div class="col-12">
          <ValidationObserver ref="observer" v-slot="{ passes }">
            <form class="" v-on:submit.prevent="passes(submitInvestement)">
              <div class="form-group">
                <label for>{{ $t('apCurrency')}}</label>
                <select @change="changeAmountOpt($event)" v-model="investmentForm.currency" class="custom-select">
                  <option v-for="option in currencyOptions" :key="option.value" :value="option.value">
                      {{ option.value }}
                    </option>
                </select>
              </div>
              <div class="form-group">
                <label for>{{ $t('table.nominalFund')}}</label>
                <select v-if="!isManual" v-model="investmentForm.amount" class="custom-select">
                  <option v-for="option in amountOptions" v-bind:key="option.value" :value="option.value">
                    {{ option.text }}
                  </option>
                </select>

                <ValidationProvider v-if="isManual && investmentForm.currency == 'IDR'" name="amount" rules="min_value:250000000" v-slot="{ errors }">
                  <input v-model="investmentForm.amount" class="form-control" type="text">
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>

                <ValidationProvider v-if="isManual && investmentForm.currency == 'USD'" name="amount" rules="min_value:20000" v-slot="{ errors }">
                  <input v-model="investmentForm.amount" class="form-control" type="text">
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>

                <div>
                  <label>
                    <input type="checkbox" v-model="isManual">{{ $t('calcOther') }}
                  </label>
                </div>
              </div>
              <div class="form-group">
                <label for>{{ $t('apSelectTimePeriod')}}</label>
                <select v-model="investmentForm.timePeriod" class="custom-select">
                  <option v-for="option in timePeriodOptions" v-bind:key="option.value" :value="option.value">
                    {{ option.text }} {{ $t('calYear')}}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <label for>{{ $t('apDateofPlacement')}}</label>
                <ValidationProvider name="investment_date" rules="required" v-slot="{ errors }">
                  <input v-model="investmentForm.investmentDate" id="investment_date" type="text"  readonly="readonly" autocomplete="off" class="form-control bg-white datepicker"/>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <p id="tmbh-dana-btn" class="mt-4">
                <button type="submit" class="tmbh-dana-btn btn btn-primary bg-success text-white text-uppercase sumbit-button" style="border: none">{{ $t('apAdd')}}</button>
              </p>
            </form>
          </ValidationObserver>

          <h5 class="text-result text-center text-success mt-2">{{dataSuccess}}</h5>
          <h5 class="text-result text-center text-danger">{{dataErr}}</h5>

          <div class="info-transfer-pendanaan mt-4">
            <p> {{ $t('bankLine1')}}<br/>
                {{ $t('bankLine2')}}<br/>
                {{ $t('bankLine3')}}<br/>
                {{ $t('bankLine4')}}<br/>
                {{ $t('bankLine5')}}<br/>
                {{ $t('bankLine6')}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { ValidationObserver, ValidationProvider } from "vee-validate";

import { mapState, mapActions } from 'vuex'

export default {
  name: "AddPriorityInvestment",
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      isManual: false,
      dataSuccess: "",
      dataErr: ""
    }
  },
  computed: {
    ...mapState([
      'currencyOptions',
      'timePeriodOptions',
      'amountOptions',
      'investmentForm'
    ])
  },
  mounted: function() {
    var self = this;
    $("#investment_date").datepicker({
      dateFormat: 'dd M yy',
      minDate: new Date(),
      onSelect:function(selectedDate, datePicker) {
        let formatSelectedDate = self.$options.filters.formatDate(selectedDate);
        self.investmentForm.investmentDate = formatSelectedDate;
      }
    });
  },

  methods: {
    ...mapActions(['resetAddInvestmentForm', 'changeCurrency']),
    submitInvestement() {

      let objAddInvestment = {
        "currency": this.investmentForm.currency,
        "amount": this.investmentForm.amount,
        "timePeriod": this.investmentForm.timePeriod,
        "investmentDate": this.investmentForm.investmentDate
      }

      this.$axios.post('/api/v1/priority/user/investments', objAddInvestment)
      .then(response =>  {
        this.resetAddInvestmentForm()
        this.$refs.observer.reset();
        this.dataSuccess = "Request penambahan dana sukses diajukan";
        this.dataErr = ""
      })
      .catch(err => {
        this.dataErr = "Request penambahan dana gagal diajukan";
        this.dataSuccess =""
      });
    },
    changeAmountOpt(e) {
      let currency = e.target.value
      if(currency == "IDR") {
        this.isManual = false
      }
      this.changeCurrency(currency)
    }
  }
};
</script>

<style>
.tmbh-dana-btn {
  font-size: 23px;
  padding: 8px 50px;
  border-radius: 25px;
}
.success-notification {
  font-size: 20px;
}
.info-transfer-pendanaan ul {
  padding-left: 0px;
  margin-bottom: 0rem;
}

@media screen and (max-width: 767px) {
  #tmbh-dana-btn {
    text-align: center;
  }
  .tmbh-dana-btn {
    font-size: 20px;
    padding: 6px 40px;
    border-radius: 25px;
  }
  .header-form-tmbh-pendanaan {
    font-size: 25px;
    text-align: center;
  }
  .success-notification {
    font-size: 15px;
  }
  .info-transfer-pendanaan ul {
    font-size: 12px;
    padding-left: 0px;
    margin-bottom: 0rem;
  }
  .text-result {
    font-size: 16px;
  }
}
</style>